import { render, staticRenderFns } from "./seat-map-info-button.vue?vue&type=template&id=136b96c6"
import script from "./seat-map-info-button.vue?vue&type=script&lang=js"
export * from "./seat-map-info-button.vue?vue&type=script&lang=js"
import style0 from "./seat-map-info-button.vue?vue&type=style&index=0&id=136b96c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports